import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

function formatErr(d) {
  if (!d) return "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d.msg || JSON.stringify(d);
}

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(email, password, name);
      nav("/dashboard");
    } catch (e2) {
      setErr(formatErr(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md bg-white border border-[#EAE5D9] rounded-2xl p-10">
        <div className="text-xs uppercase tracking-[0.25em] text-[#8A857D] text-center">Begin the journey</div>
        <h1 className="font-display text-4xl text-[#2D2A26] text-center mt-2">Create your account</h1>
        <p className="text-sm text-[#5C5852] text-center mt-3">
          Start with the free preview lesson. No payment required.
        </p>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-[#5C5852]">Name</label>
            <input
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="register-name"
              className="w-full mt-1 px-4 py-3 rounded-xl border border-[#EAE5D9] bg-[#FDFBF7] focus:outline-none focus:border-[#A36B5E]"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-[#5C5852]">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="register-email"
              className="w-full mt-1 px-4 py-3 rounded-xl border border-[#EAE5D9] bg-[#FDFBF7] focus:outline-none focus:border-[#A36B5E]"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-[#5C5852]">Password</label>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="register-password"
              className="w-full mt-1 px-4 py-3 rounded-xl border border-[#EAE5D9] bg-[#FDFBF7] focus:outline-none focus:border-[#A36B5E]"
            />
          </div>
          {err && <div className="text-sm text-red-600" data-testid="register-error">{err}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid="register-submit"
            className="btn-primary w-full rounded-full py-3 font-medium disabled:opacity-50"
          >
            {loading ? "Creating..." : "Create account"}
          </button>
        </form>
        <div className="mt-6 text-center text-sm text-[#5C5852]">
          Already have an account?{" "}
          <Link to="/login" className="text-[#A36B5E]">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
